import platformUtils from '../platformUtils';
import _ from 'lodash';

function addAppStudioWidgetPropsToSelector(props) {
    if (!self.$widget){return;}
    self.$widget.props = {};
    _.forEach(props, (val, key) => {
        Object.defineProperty(self.$widget.props, key, {
            writable: false,
            value: val
        });
    });
}

function addAppStudioGlobalsIfNeeded() {
    const RGI = platformUtils.getRGI();
    if (RGI.getIsApplicationStudio()) {
        self.$widget = {};
        self.$widget.fireEvent = function (eventName) {
            console.log(`Event Fired: ${eventName}`);
        };
        self.$widget.onPropsChanged = function (callback) {
            RGI.addOnWidgetPropsChangedCallback((oldProps, newProps) => {
                callback(oldProps, newProps);
            });
        };
    }
}

function setWidgetProperties(props) {
    const RMI = platformUtils.getRMI();
    const pageData = RMI.getPageData();
    const components = RMI.getComponents();
    const widgetRoot = _.findKey(components, {parent: pageData.currentNavigationInfo.pageId});
    const publicAPI = RMI.getPublicAPI(widgetRoot)();

    _.assign(publicAPI, props);
}

export default {
    addAppStudioWidgetPropsToSelector,
    addAppStudioGlobalsIfNeeded,
    setWidgetProperties
};
